import { Icon } from '@chakra-ui/react';
import { CgGym } from "react-icons/cg";
import {
    MdAccountBalanceWallet,
    MdAutoGraph,
    MdBusinessCenter,
    MdCalendarMonth,
    MdCampaign,
    MdChat,
    MdCardMembership,
    MdEmojiEvents,
    MdEvent,
    MdHeadsetMic,
    MdHome,
    MdInsights,
    MdLeaderboard,
    MdLocationPin,
    MdLocalOffer,
    MdMap,
    MdNewspaper,
    MdOutlineShoppingCart,
    MdPriceChange,
    MdSportsBasketball,
    MdSportsTennis,
    MdLiveTv,
    MdNotifications,
    MdNotificationsActive,
    MdReceipt,
    MdSensorDoor,
    MdSmartToy,
    MdSupervisorAccount,
    MdTrendingDown,
    MdTune,
    MdVideocam,
    MdVideoLibrary,
    MdVpnKey,
    MdRocketLaunch,
} from 'react-icons/md';

// Feature Imports
import HomePage from '../features/walkthrough/HomePage';
import PayLaterCoachingListPage from '../features/pay-later-coaching/PayLaterCoachingListPage';
import AnalyticsPage from '../features/analytics/AnalyticsPage';
import ImpactPage from '../features/impact/ImpactPage';
import ArticleList from '../features/article-management/components/ArticleList';
import CampaignManagementPage from '../features/campaign-management/CampaignManagementPage';
import CampaignDetailPage from '../features/campaign-management/components/CampaignDetailPage';
import CoachDetailsPage from '../features/coach-management/CoachDetailsPage';
import CoachList from '../features/coach-management/components/CoachList';
import CouponDetailPage from '../features/coupon-management/components/CouponDetailPage';
import CouponList from '../features/coupon-management/components/CouponList';
import CreditPackList from '../features/credit-pack-management/components/CreditPackList';
import SponsorList from '../features/sponsor-management/components/SponsorList';
import CoachingSessionDetailsPage from '../features/coaching-session-details/CoachingSessionDetailsPage';
import AccessCodesPage from '../features/access-codes-management/AccessCodesPage';
import AccessControlPage from '../features/access-control/AccessControlPage';
import CourtDetailsPage from '../features/court-details/CourtDetailsPage';
import CourtTable from '../features/court-management/components/CourtList';
import CourtsCalendarPage from '../features/courts-calendar/CourtsCalendarPage';
import EventList from '../features/event-management/components/EventList';
import EventDetailsPage from '../features/event-details/EventDetailsPage';
import GameDetailsPage from '../features/game-details/GameDetailsPage';
import LatestBookedGamesPage from '../features/game-management/LatestBookedGamesPage';
import LocationTable from '../features/location-management/pages/LocationListPage';
import EditLocationPage from '../features/location-management/pages/LocationPage';
import OrganizationPage from '../features/organization/OrganizationPage';
import ApiKeysPage from '../features/api-keys/ApiKeysPage';
import PricingInsightsPage from '../features/pricing-insights/PricingInsightsPage';
import PricingManagementPage from '../features/pricing-management/PricingManagementPage';
import ProductManagementPage from '../features/product-management/ProductManagementPage';
import AdminNotificationListPage from '../features/admin-notifications/AdminNotificationListPage';
import NotificationListPage from '../features/notification-management/NotificationListPage';
import SupportRequestsPage from '../features/support-management/SupportRequestsPage';
import UserList from '../features/user-management/components/UserList';
import UserMembershipTypesList from '../features/user-management/components/UserMembershipTypesPage';
import UserPage from '../features/user-management/components/UserPage';
import UsersWithMembershipsTable from '../features/user-management/components/UsersWithMembershipsTable';
import AiAssistantPage from '../features/ai-assistant/AiAssistantPage';
import VideoSubmissionList from '../features/video-review/components/VideoSubmissionList';
import VideoSubmissionDetailPage from '../features/video-review/VideoSubmissionDetailPage';
import EloSettingsPage from '../features/elo-settings/EloSettingsPage';
import LeaderboardPage from '../features/leaderboard/LeaderboardPage';
import RoadmapPage from '../features/roadmap/RoadmapPage';
import RoadmapMappingPage from '../features/roadmap/RoadmapMappingPage';
import ProvisionOrganizationPage from '../features/organization-provisioning/ProvisionOrganizationPage';
import TransactionHistoryPage from '../features/transaction-history/TransactionHistoryPage';
import CohortList from '../features/user-cohort/components/CohortList';
import CohortDetailPage from '../features/user-cohort/components/CohortDetailPage';
import ChurnPredictionPage from '../features/churn-prediction/ChurnPredictionPage';
import CourtRecordingPage from '../features/court-recording/CourtRecordingPage';
import CourtRecordingDetailPage from '../features/court-recording/CourtRecordingDetailPage';
import VenueAgentsPage from '../features/court-recording/VenueAgentsPage';
import CameraAimPage from '../features/court-recording/CameraAimPage';
import AchievementListPage from '../features/achievement-management/components/AchievementListPage';
import AchievementDetailPage from '../features/achievement-management/components/AchievementDetailPage';
import ConversationList from '../features/whatsapp-conversations/components/ConversationList';
import ConversationDetailPage from '../features/whatsapp-conversations/components/ConversationDetailPage';
import HelpArticleList from '../features/help-center/components/HelpArticleList';
import HelpArticleEditor from '../features/help-center/components/HelpArticleEditor';
import HelpCategoryManager from '../features/help-center/components/HelpCategoryManager';
import VenueDisplayShowcasePage from '../features/venue-display/VenueDisplayShowcasePage';
import VenueDisplayCalmLive from '../features/venue-display/live/VenueDisplayCalmLive';
import { translate } from '../i18n'; // Adjust the path as necessary
import { RType } from './types';

export const homeRoute: RType = {
  name: translate('walkthrough.home'),
  layout: '/admin',
  path: '/home',
  hidden: false,
  icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  component: <HomePage />,
};

export const organizationRoute: RType = {
  name: translate('tabs.organization'),
  layout: '/admin',
  path: '/organization',
  hidden: false,
  group: 'sidebar.groups.organization',
  icon: <Icon as={MdBusinessCenter} width="20px" height="20px" color="inherit" />,
  component: <OrganizationPage />,
};
export const locationRoute: RType = {
  name: translate('tabs.locations'),
  layout: '/admin',
  path: '/locations',
  group: 'sidebar.groups.organization',
  icon: <Icon as={MdLocationPin} width="20px" height="20px" color="inherit" />,
  component: <LocationTable />,
};

export const apiKeysRoute: RType = {
  name: translate('tabs.nextore' as any),
  layout: '/admin',
  path: '/api-keys',
  group: 'sidebar.groups.system',
  icon: <Icon as={MdVpnKey} width="20px" height="20px" color="inherit" />,
  component: <ApiKeysPage />,
};

const additionalRoutes: RType[] = [
  {
    name: translate('tabs.courts'),
    layout: '/admin',
    path: '/courts',
    activePaths: ['/courtDetails'],
    group: 'sidebar.groups.organization',
    icon: <Icon as={MdSportsBasketball} width="20px" height="20px" color="inherit" />,
    component: <CourtTable />,
  },
  {
    name: translate('tabs.access_codes'),
    layout: '/admin',
    path: '/access-codes',
    group: 'sidebar.groups.organization',
    icon: <Icon as={MdVpnKey} width="20px" height="20px" color="inherit" />,
    component: <AccessCodesPage />,
    requiresOrgFeature: 'gameBookingCodeEnabled',
  },
  {
    name: translate('tabs.access_control' as any),
    layout: '/admin',
    path: '/access-control',
    group: 'sidebar.groups.organization',
    icon: <Icon as={MdSensorDoor} width="20px" height="20px" color="inherit" />,
    component: <AccessControlPage />,
  },
  {
    name: translate('tabs.users'),
    layout: '/admin',
    path: '/users',
    activePaths: ['/userDetails'],
    group: 'sidebar.groups.users',
    icon: <Icon as={MdSupervisorAccount} width="20px" height="20px" color="inherit" />,
    component: <UserList />,
  },
  {
    name: translate('tabs.memberships'),
    layout: '/admin',
    path: '/memberships',
    group: 'sidebar.groups.users',
    icon: <Icon as={MdCardMembership} width="20px" height="20px" color="inherit" />,
    component: <UserMembershipTypesList />,
  },
  {
    name: translate('userMembership.users_with_memberships_title'),
    layout: '/admin',
    path: '/subscribed-users',
    group: 'sidebar.groups.users',
    icon: <Icon as={MdCardMembership} width="20px" height="20px" color="inherit" />,
    component: <UsersWithMembershipsTable />,
  },
  {
    name: translate('cohort.cohorts'),
    layout: '/admin',
    path: '/user-management/cohorts',
    group: 'sidebar.groups.users',
    icon: <Icon as={MdSupervisorAccount} width="20px" height="20px" color="inherit" />,
    component: <CohortList />,
  },
  {
    name: translate('leaderboard.title'),
    layout: '/admin',
    path: '/leaderboard',
    group: 'sidebar.groups.users',
    icon: <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />,
    component: <LeaderboardPage />,
  },
  {
    name: translate('organization.elo_settings'),
    layout: '/admin',
    path: '/elo-settings',
    group: 'sidebar.groups.users',
    icon: <Icon as={MdTune} width="20px" height="20px" color="inherit" />,
    component: <EloSettingsPage />,
  },
  {
    name: 'Cohort Details',
    layout: '/admin',
    path: '/user-management/cohorts/:cohortId',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <CohortDetailPage />,
  },
  {
    name: translate('tabs.events'),
    layout: '/admin',
    path: '/events',
    group: 'sidebar.groups.content',
    icon: <Icon as={MdEvent} width="20px" height="20px" color="inherit" />,
    component: <EventList />,
  },
  {
    name: translate('tabs.articles') || 'Articles',
    layout: '/admin',
    path: '/articles',
    group: 'sidebar.groups.content',
    icon: <Icon as={MdNewspaper} width="20px" height="20px" color="inherit" />,
    component: <ArticleList />,
  },
  {
    name: translate('tabs.video_reviews'),
    layout: '/admin',
    path: '/video-reviews',
    group: 'sidebar.groups.content',
    icon: <Icon as={MdVideoLibrary} width="20px" height="20px" color="inherit" />,
    component: <VideoSubmissionList />,
  },
  {
    name: 'Video Review Detail',
    layout: '/admin',
    path: '/video-review-detail',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <VideoSubmissionDetailPage />,
  },
  {
    name: translate('achievement.achievements'),
    layout: '/admin',
    path: '/achievements',
    group: 'sidebar.groups.content',
    icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />,
    component: <AchievementListPage />,
  },
  {
    name: 'Achievement Details',
    layout: '/admin',
    path: '/achievements/:achievementId',
    hidden: true,
    icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />,
    component: <AchievementDetailPage />,
  },
  {
    name: translate('help_center.title'),
    layout: '/admin',
    path: '/help-center',
    group: 'sidebar.groups.content',
    hidden: true,
    icon: <Icon as={MdNewspaper} width="20px" height="20px" color="inherit" />,
    component: <HelpArticleList />,
  },
  {
    name: 'New Article',
    layout: '/admin',
    path: '/help-center/new',
    hidden: true,
    icon: <Icon as={MdNewspaper} width="20px" height="20px" color="inherit" />,
    component: <HelpArticleEditor />,
  },
  {
    name: 'Edit Article',
    layout: '/admin',
    path: '/help-center/:id/edit',
    hidden: true,
    icon: <Icon as={MdNewspaper} width="20px" height="20px" color="inherit" />,
    component: <HelpArticleEditor />,
  },
  {
    name: 'Help Categories',
    layout: '/admin',
    path: '/help-center/categories',
    hidden: true,
    icon: <Icon as={MdNewspaper} width="20px" height="20px" color="inherit" />,
    component: <HelpCategoryManager />,
  },
  {
    name: translate('tabs.sponsors') || 'Sponsors',
    layout: '/admin',
    path: '/sponsors',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdLocalOffer} width="20px" height="20px" color="inherit" />,
    component: <SponsorList />,
  },
  {
    name: translate('coupon.coupons'),
    layout: '/admin',
    path: '/coupons',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdPriceChange} width="20px" height="20px" color="inherit" />,
    component: <CouponList />,
  },
  {
    name: 'Coupon Details',
    layout: '/admin',
    path: '/coupons/:couponId',
    hidden: true,
    icon: <Icon as={MdPriceChange} width="20px" height="20px" color="inherit" />,
    component: <CouponDetailPage />,
  },
  {
    name: translate('credit_pack.credit_packs'),
    layout: '/admin',
    path: '/credit-packs',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdAccountBalanceWallet} width="20px" height="20px" color="inherit" />,
    component: <CreditPackList />,
  },
  {
    name: translate('campaign.campaigns'),
    layout: '/admin',
    path: '/campaigns',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />,
    component: <CampaignManagementPage />,
  },
  {
    name: 'Campaign Details',
    layout: '/admin',
    path: '/campaigns/:campaignId',
    hidden: true,
    icon: <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />,
    component: <CampaignDetailPage />,
  },
  {
    name: translate('tabs.coachs'),
    layout: '/admin',
    path: '/coachs',
    activePaths: ['/coachDetails'],
    group: 'sidebar.groups.content',
    icon: <Icon as={CgGym} width="20px" height="20px" color="inherit" />,
    component: <CoachList />,
  },
  {
    name: translate('tabs.products'),
    layout: '/admin',
    path: '/products',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdOutlineShoppingCart} width="20px" height="20px" color="inherit" />,
    component: <ProductManagementPage />,
  },
  {
    name: 'Coach Details',
    layout: '/admin',
    path: '/coachDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <CoachDetailsPage />,
  },
  {
    name: 'Location Details',
    layout: '/admin',
    path: '/locationDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <EditLocationPage />,
  },
  {
    name: translate('tabs.calendar'),
    layout: '/admin',
    path: '/calendar',
    group: 'sidebar.groups.content',
    icon: <Icon as={MdCalendarMonth} width="20px" height="20px" color="inherit" />,
    component: <CourtsCalendarPage />,
  },
  {
    name: translate('tabs.venue_display' as any) || 'Venue Display',
    layout: '/admin',
    path: '/venue-display',
    group: 'sidebar.groups.content',
    icon: <Icon as={MdLiveTv} width="20px" height="20px" color="inherit" />,
    component: <VenueDisplayShowcasePage />,
  },
  {
    name: 'Venue Display — Live',
    layout: '/admin',
    path: '/venue-display/live',
    hidden: true,
    icon: <Icon as={MdLiveTv} width="20px" height="20px" color="inherit" />,
    component: <VenueDisplayCalmLive />,
  },
  {
    name: translate('tabs.pricing'),
    layout: '/admin',
    path: '/pricing',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdPriceChange} width="20px" height="20px" color="inherit" />,
    component: <PricingManagementPage />,
  },
  {
    name: translate('tabs.pricing_insights' as any) || 'Pricing Advisor',
    layout: '/admin',
    path: '/pricing-advisor',
    group: 'sidebar.groups.commerce',
    icon: <Icon as={MdAutoGraph} width="20px" height="20px" color="inherit" />,
    component: <PricingInsightsPage />,
    hidden: true,
  },
  {
    name: translate('tabs.analytics'),
    layout: '/admin',
    path: '/analytics',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdAutoGraph} width="20px" height="20px" color="inherit" />,
    component: <AnalyticsPage />,
  },
  {
    name: translate('tabs.impact'),
    layout: '/admin',
    path: '/impact',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdInsights} width="20px" height="20px" color="inherit" />,
    component: <ImpactPage />,
  },
  {
    name: translate('tabs.games'),
    layout: '/admin',
    path: '/latest-booked-games',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdSportsTennis} width="20px" height="20px" color="inherit" />,
    component: <LatestBookedGamesPage />,
  },
  {
    name: translate('tabs.transactions'),
    layout: '/admin',
    path: '/transactions',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdReceipt} width="20px" height="20px" color="inherit" />,
    component: <TransactionHistoryPage />,
  },
  {
    name: 'Paiements differes',
    layout: '/admin',
    path: '/pay-later-coaching',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdPriceChange} width="20px" height="20px" color="inherit" />,
    component: <PayLaterCoachingListPage />,
  },
  {
    name: translate('tabs.churn_prediction' as any),
    layout: '/admin',
    path: '/churn-prediction',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdTrendingDown} width="20px" height="20px" color="inherit" />,
    component: <ChurnPredictionPage />,
  },
  {
    name: translate('tabs.court_recording'),
    layout: '/admin',
    path: '/court-recording',
    group: 'sidebar.groups.data',
    icon: <Icon as={MdVideocam} width="20px" height="20px" color="inherit" />,
    component: <CourtRecordingPage />,
  },
  {
    name: translate('tabs.venue_agents'),
    layout: '/admin',
    path: '/court-recording/venue-agents',
    group: 'sidebar.groups.data',
    // The aim view is reached from this page's camera panel and returns to it.
    activePaths: ['/court-recording/aim'],
    icon: <Icon as={MdVideocam} width="20px" height="20px" color="inherit" />,
    component: <VenueAgentsPage />,
  },
  {
    // Camera aim view — opened from "Viser en direct" on the Caméra → Terrain
    // panel, `?camera=<MAC>` picks the camera (docs/epics/camera-aim-live-view.md).
    name: translate('court_recording.camera_aim.title'),
    layout: '/admin',
    path: '/court-recording/aim/:agentId',
    hidden: true,
    icon: <Icon as={MdVideocam} width="20px" height="20px" color="inherit" />,
    component: <CameraAimPage />,
  },
  {
    name: 'Recording Details',
    layout: '/admin',
    path: '/court-recording/:recordingId',
    hidden: true,
    icon: <Icon as={MdVideocam} width="20px" height="20px" color="inherit" />,
    component: <CourtRecordingDetailPage />,
  },
  {
    name: translate('tabs.notifications' as any),
    layout: '/admin',
    path: '/notifications',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdNotifications} width="20px" height="20px" color="inherit" />,
    component: <NotificationListPage />,
  },
  {
    name: translate('admin_notifications.title' as any),
    layout: '/admin',
    path: '/admin-notifications',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdNotificationsActive} width="20px" height="20px" color="inherit" />,
    component: <AdminNotificationListPage />,
  },
  {
    name: translate('tabs.support' as any),
    layout: '/admin',
    path: '/support-requests',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdHeadsetMic} width="20px" height="20px" color="inherit" />,
    component: <SupportRequestsPage />,
  },
  {
    name: translate('roadmap.title'),
    layout: '/admin',
    path: '/roadmap',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdMap} width="20px" height="20px" color="inherit" />,
    component: <RoadmapPage />,
  },
  {
    name: translate('roadmap.mapping_title'),
    layout: '/admin',
    path: '/roadmap-mapping',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdTune} width="20px" height="20px" color="inherit" />,
    component: <RoadmapMappingPage />,
  },
  {
    name: translate('org_provisioning.title'),
    layout: '/admin',
    path: '/provision-organization',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdRocketLaunch} width="20px" height="20px" color="inherit" />,
    component: <ProvisionOrganizationPage />,
    requiresElevatedAdmin: true,
  },
  {
    name: 'AI Assistant',
    layout: '/admin',
    path: '/ai-assistant',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdSmartToy} width="20px" height="20px" color="inherit" />,
    component: <AiAssistantPage />,
  },
  {
    name: translate('tabs.whatsapp_conversations' as any),
    layout: '/admin',
    path: '/whatsapp-conversations',
    group: 'sidebar.groups.system',
    icon: <Icon as={MdChat} width="20px" height="20px" color="inherit" />,
    component: <ConversationList />,
  },
  {
    name: 'Conversation Detail',
    layout: '/admin',
    path: '/whatsapp-conversations/:conversationId',
    hidden: true,
    icon: <Icon as={MdChat} width="20px" height="20px" color="inherit" />,
    component: <ConversationDetailPage />,
  },
  {
    name: 'User Details',
    layout: '/admin',
    path: '/userDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <UserPage />,
  },
  {
    name: 'Court Details',
    layout: '/admin',
    path: '/courtDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <CourtDetailsPage />,
  },
  {
    name: 'Game Details',
    layout: '/admin',
    path: '/gameDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <GameDetailsPage />,
  },
  {
    name: 'Coaching Session Details',
    layout: '/admin',
    path: '/coachingSessionDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <CoachingSessionDetailsPage />,
  },
  {
    name: 'Event Details',
    layout: '/admin',
    path: '/eventDetails',
    hidden: true,
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <EventDetailsPage />,
  },
];
const adminRoutes = [
  homeRoute,
  organizationRoute,
  locationRoute,
  apiKeysRoute,
  ...additionalRoutes,
];
export default adminRoutes;
